import { render } from "./BrandingPreview.vue?vue&type=template&id=25b2b6fe"
import script from "./BrandingPreview.vue?vue&type=script&lang=js"
export * from "./BrandingPreview.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__